import React, { PropsWithChildren } from 'react';
import { Modal, ModalHeader, ModalFooter, Button, ModalBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { EhpcMessageValues } from '../../Messages';

/**
 *
 */
export interface BasePreviewModalProps {
  open: boolean;
  setOpen: Function;
  headerId: string;
  headerValues?: EhpcMessageValues;
}

export type PreviewModalProps = PropsWithChildren<BasePreviewModalProps>;

export const PreviewModal: React.FC<PreviewModalProps> = ({ 
  open, setOpen,
  children,
  headerId, headerValues = undefined }): JSX.Element | null => {

  return (
    <React.Fragment>
      <Modal isOpen={open} toggle={() => {setOpen(!open)}} size="xl" scrollable>
        <ModalHeader>
          <FormattedMessage id={headerId} values={headerValues} />
        </ModalHeader>
        <ModalBody>
          {children}
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => setOpen(false)}>
            <FormattedMessage id="button_close"/>
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );

}
